module.exports = "module.exports = __webpack_public_path__ + \"static/media/tableHeader.f78f7ff4.template\";"